import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFooter,{staticClass:"bt4 pa-4 blue-grey darken-4 d-flex justify-space-around"},[_c('span',{staticClass:"white--text text-center py-2"},[_vm._v(_vm._s(_vm.name)+" © 2020. Todos os direitos reservados.")]),_c('img',{attrs:{"src":"/img/mrx.png","alt":"MRX Web Sites","title":"MRX Web Sites"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }